<template>
	<div class="card">
		<div class="card-header">
			<h1>Backlogin</h1>
		</div>
		<div class="card-body text-center">
			<div id="login">
				<input type="text" name="username" v-model="input.username" placeholder="Username" />
				<input type="password" name="password" v-model="input.password" placeholder="Password" />
				<button type="button" v-on:click="login()">Login</button>
				<div>{{ message }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
	name: "Login",
	mixins: [Mixin],
	data() {
		return {
			input: {
				username: "",
				password: ""
			},
			message: ""
		};
	},
	methods: {
		login: function() {
			this.$store
				.dispatch("http_backlogin", {
					username: this.input.username,
					password: this.input.password
				})
				.then(resp => {
					localStorage.setItem("token", String(resp.token).trim());
					this.$router.go("/home").catch(err => {
						console.log(err);
					});
				})
				.catch(e => {
					this.message = "Λάθος στοιχεία";
					console.error(e);
				});
		}
	}
};
</script>

<style scoped>
#login {
	width: 500px;
	border: 1px solid #cccccc;
	background-color: #ffffff;
	margin: auto;
	margin-top: 0px;
	padding: 20px;
}
</style>
